import { Route, Routes } from "react-router-dom";
import LoginPage from "../Pages/Login"
import RegisterPage from "../Pages/Register"
import DashBoard from "../Pages/Dashboard";
import { Navigate } from "react-router-dom";

const RoutesComponent = () =>{

    return(
        <Routes>
            <Route path="/" element={<Navigate to="/login"/>} />
            <Route path="/login" element={<LoginPage/>}/>
            <Route path="/register" element={<RegisterPage/>}/>
            <Route path="/dashboard" element={<DashBoard/>}/>
        </Routes>
    )
}

export default RoutesComponent